import { deleteConversation2Mutation, getConversationQuery, listAllConversationsQuery, updateconversationMutation } from "../../graphql/queries";
import { DeleteConversationMutation, DeleteConversationMutationVariables, GetConversationQuery, GetConversationQueryVariables, ListAllConversationsQuery, ListAllConversationsQueryVariables, UpdateConversationMutation, UpdateConversationMutationVariables } from "../../graphql/types";
import { fetchGraphql, useGraphql } from "./graphqlClient";

export type BackendConversation = NonNullable<ListAllConversationsQuery["self"]>["conversations"][0];
export type BackendChatMessage = NonNullable<GetConversationQuery["self"]>["conversations"][0]["messages"][0];
export type BackendConversationWithMessages = NonNullable<GetConversationQuery["self"]>["conversations"][0];

export async function getAllConversations(): Promise<ListAllConversationsQuery | null> {
    const result = await fetchGraphql<ListAllConversationsQuery, ListAllConversationsQueryVariables>("ListAllConversations", listAllConversationsQuery, { }, true);
    return result.data ?? null;
}

export function useAllConversations(): { result: ListAllConversationsQuery | null } {
    return useGraphql<ListAllConversationsQuery, ListAllConversationsQueryVariables>("ListAllConversations", listAllConversationsQuery, {});
}

export async function getConversation(id: string): Promise<BackendConversationWithMessages | null> {
    const result = await fetchGraphql<GetConversationQuery, GetConversationQueryVariables>("GetConversation", getConversationQuery, { id }, true);
    return result.data?.self?.conversations[0] ?? null;
}

export async function updateConversation(id: string, opt: Omit<UpdateConversationMutationVariables, "conversation">): Promise<BackendConversation | null> {
    const result = await fetchGraphql<UpdateConversationMutation, UpdateConversationMutationVariables>("UpdateConversation", updateconversationMutation, { conversation: id, ...opt }, true);
    return result.data?.updateConversation ?? null;
}

export async function deleteConversation(id: string): Promise<boolean> {
    const result = await fetchGraphql<DeleteConversationMutation, DeleteConversationMutationVariables>("DeleteConversation", deleteConversation2Mutation, { conversation: id }, true);
    return result.data?.deleteConversation ?? false;
}
